import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DemoAccessService } from './demo-access.service';

export const demoGateGuard: CanActivateFn = (_route, state) => {
    const demoAccess = inject(DemoAccessService);
    const router = inject(Router);

    if (!demoAccess.subdomain || demoAccess.isUnlocked()) {
        return true;
    }

    return router.createUrlTree(['/demo-access'], { queryParams: { returnUrl: state.url } });
};
